<template>

  <!-- <div id="select-lab-modal" class="FCNW" v-if="showSelectLabModal">
    <h3>Select Lab From Dropdown</h3>
  </div> -->

  <div id="select-lab-modal-wrapper" class="FCNW" v-if="showSelectLabModal">
    <div id="select-lab-modal" class="FCNW" >
      <div id="select-lab-modal-header">
        <CloseBtnVue
          :closeFunc="toggleSelectLabModal"
        />
      </div>

      <h3>Select Lab From Dropdown</h3>

      <div id="select-lab-modal-body">
        <input 
          id="auto-complete" 
          type="text"
          @change="handleChange"
          v-model="selectedLab"
          placeholder="Type to search lab"
        >
      </div>

      <div id="select-lab-modal-footer">
        <ModernButtonVue
          :btnText="'Add To Favorites'"
          :btnSize="'small'"
          :disabled="disableContinueBtn"
          :clickFunc="() => modifyFavorites('add')"
        />
        <ModernButtonVue
          :btnText="'Continue'"
          :btnSize="'small'"
          :disabled="disableContinueBtn"
          :clickFunc="goToLabOrderPage"
        />
      </div>
    </div>
  </div>

  <div id="order-details-modal-wrapper" class="FCNW" v-if="showOrderDetailsModal">
    <div id="order-details-modal" class="FCNW">
      <div id="select-lab-modal-header">
        <CloseBtnVue
          :closeFunc="() => toggleOrderDetails()"
        />
      </div>
      <div class="modal-body">
        <div class="FRNW info-line">
          <div class="right bold">Lab Name: </div>
          <div class="left margin-left">{{ selectedOrderDetails.labOptionsId.labName }}</div>
        </div>
        <div class="FRNW info-line">
          <div class="right bold">Order #: </div>
          <div class="left margin-left">{{ selectedOrderDetails.orderNumber }}</div>
        </div>
        <div class="FRNW info-line">
          <div class="right bold">Status: </div>
          <div class="left margin-left">{{ selectedOrderDetails.status }}</div>
        </div>
        <div class="FRNW info-line">
          <div class="right bold">Order Date: </div>
          <div class="left margin-left">{{ stringToLocaleDate(selectedOrderDetails.orderDate) }}</div>
        </div>
        <div class="FRNW info-line">
          <div class="right bold">Total: </div>
          <div class="left margin-left">$ {{ selectedOrderDetails.totalCostDollars }}</div>
        </div>
        <div class="FRNW info-line">
          <div class="right bold">Neg Return: </div>
          <div class="left margin-left">{{ selectedOrderDetails?.negReturnDetails?.type || 'N/A' }}</div>
        </div>

        <!-- FOR LINE ITEMS -->
        <div class="FCNW">
          <div class="bold">Items</div>
          <div class=table-wrapper>
            <table class="modern-table">
              <thead>
                <tr>
                  <th 
                    v-for="val of Object.values( labOptionsArrayMap )" 
                    :key="val"
                  >
                    {{ val }}
                  </th>
                  <th>Item Total</th>
                  <th>Qty</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item of selectedOrderDetails.itemList" :key="item._id">
                  <td v-for="key of Object.keys( labOptionsArrayMap )" :key=key>
                    {{ mutateItemDetails( item.itemDetails[key] ) }}
                  </td>
                  <td>$ {{ item.itemTotal }}</td>
                  <td>{{ item.qty }}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>

    </div>

  </div>

  <div 
    id="new-order-div"
    class="FCNW"
  >
    <div class="FRNW new-order-wrapper" >
      <h2>Create a New Order</h2>
      <div class="">
        <ModernButtonVue
          :btnText="'Find Film Lab'"
          :clickFunc="toggleSelectLabModal"
          :btnSize="'small'"
          :showBorder="true"
        />
      </div>
    </div>
    
    <!-- USER LAB FAVORITES -->
    <div 
      v-if="userInfo?.favoriteLabs?.length"
      id="favorite-labs"
      class="FCNW"
    >
      <h3>Favorite Labs:</h3>
      <div class="FRW">
        <div
          class="favorite-btn FRNW"
          v-for="lab of userInfo.favoriteLabs"
          :key="lab._id"
          @click="goToLabOrderPage( lab._id )"
          :title="`Go to order page for ${lab.labName}`"
        >

          {{ lab.labName }}

          <CloseBtnVue
            style="margin-left: 1rem;"
            :title="`Remove (${lab.labName}) from favorites`"
            :closeFunc="() => modifyFavorites('remove', lab._id)"
          />

        </div>
      </div>

    </div>


  </div>
 
  <div id="past-orders-wrapper">
    <h3>Past Orders</h3>
    <div class="FRW" style="justify-content: space-between;">
      <div class="FRNW">
        <label>Filter By Status:</label>
        <select v-model="statusFilter">
          <option value="">All</option>
          <option
            v-for="status of orderStatusArr"
            :value="status"
            :key="status"
          >
            {{ `${status} (${orderStatusCountMap[status]})` }}
          </option>
        </select>
      </div>
      <div class="FRNW">
        <label>Search:</label>
        <input 
          id="search-input"
          type="text" 
          v-model="searchText" 
          placeholder="order # or user name"
          @change="searchText = searchText.trim()"
          >
        <InfoVue
          :title="'Search by order number or lab name.'"
        />
      </div>
    </div>
    <div class="FRW" style="justify-content: space-between;">
      <!-- FILTER BY DATE ROW -->
      <div class="FRNW" style="margin-top: .5rem;">
        <label class="bold">Start:</label>
        <input 
          type="date" 
          style="margin-right: 1rem;"
          v-model="startDate"
        >
        <label class="bold">End:</label>
        <input 
          type="date" 
          style="margin-right: 1rem;"
          v-model="endDate"
        >
      </div>
    </div>
    <div id="past-orders" class="table-wrapper">
      <table class="modern-table">
        <thead>
          <tr>
            <th>Lab Name</th>
            <th>Order #</th>
            <th>Order Date</th>
            <th>Status</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr 
            v-for="order of filteredOrders" 
            :key="order._id"
            @click="toggleOrderDetails( order._id )"
            class="pointer"
          >
            <td>{{ order.labOptionsId.labName }}</td>
            <td>{{ order.orderNumber }}</td>
            <td>{{ new Date(order.orderDate).toLocaleDateString() }}</td>
            <td>{{ order.status }}</td>
            <td>${{ order.totalCostDollars }}</td>
          </tr>
        </tbody>
      </table>

    </div>

  </div>
  


  <!-- SECTION FOR AUTO COMPLETE WHEN SELECTING LAB -->
   


</template>


<script>
import Awesomplete from 'awesomplete';
import ModernButtonVue from './basicComponents/ModernButton.vue';
import CloseBtnVue from './basicComponents/CloseButton.vue';
import InfoVue from './basicComponents/Info.vue';
import router from '../router/index.js';
import { GetDate, LocalStorageFuncs, IsMobileDevice } from '../utils';



// GLOBALS
// --------------------
const API = process.env.VUE_APP_API_URL;
let NOTIFICATION, FLA_AXIOS;
const NAME = 'OrdersViewUser';
// --------------------



export default {
  name: NAME,
  components: {
    ModernButtonVue,
    CloseBtnVue,
    InfoVue,
  },
  props: {
    userId: String,
  },
  data() {
    return {
      allLabs: [],          // array of labName s
      selectedLab: '',      // this represents the labName value
      // labMap: {},           // <labName>: <labOptionsId>
      labOptions: {},       // labOptions associated with the selected lab


      cartVisible: false,
      shoppingCart: {
        // <labName>: {
        //   userId: 'this is for the user who is placing the order',
        //   itemList: [{
        //     itemTotal: this is the line total as a Number,
        //      itemDetails: { this is the object with all the line details }
        //      qty: number of this line item
        //   }],
        //   totalCostDollars: Number
        // }
      },
      lineQty: 1,
      showSelectLabModal: false,
      disableContinueBtn: true,
      userInfo: {},

      orders: [],
      selectedOrderDetails: {},

      labOptionsArrayMap: {},

      statusFilter: '',
      searchText: '',
      startDate: null,
      endDate: null,

      orderStatusArr: [],
      orderStatusCountMap: {},

    }
  },
  computed: {
    showOptions() {
      return Object.keys( this.labOptions || [] ).length;
    },
    showCart() {
      return this.shoppingCart[ this.selectedLab ]?.itemList?.length && !!this.selectedLab;
    },

    // placeholder for the current cart
    currentCart() {
      if ( !this.selectedLab || !this.shoppingCart[ this.selectedLab ] ) {
        return null;
      }
      return this.shoppingCart[ this.selectedLab ];
    },

    showOrderDetailsModal() {
      return Object?.keys(this.selectedOrderDetails || {})?.length || 0;
    },

    filteredOrders() {
      let orders = this.orders;

      // filter by status
      if ( this.statusFilter ) {
        orders = orders.filter( order => order.status === this.statusFilter );
      }

      // text filter
      const text = this.searchText.trim();
      if ( text ) {
        const re = RegExp( text, 'i' );
        orders = orders.filter( order => {
          const { orderNumber, labName } = order;
          return (
            re.test( labName ) ||
            re.test( orderNumber )
          );
        } );
      }

      // endDate filter
      if ( this.endDate ) {
        const _endDate = GetDate( this.endDate, false );
        orders = orders.filter( o => {
          const orderDate = new Date(o.orderDate);
          return orderDate <= _endDate;
        } );
      }

      // startDate filter
      if ( this.startDate ) {
        const _startDate = GetDate( this.startDate, true );
        orders = orders.filter( o => {
          const orderDate = new Date( o.orderDate );
          return orderDate >= _startDate;
        } );
      }

      return orders;
    }
  },
  methods: {

    fetchLabs() {
      FLA_AXIOS('get', API + '/api/user/fetchLabs' )
      .then( res => {

        const { allLabs } = res.data;
        this.allLabs = allLabs || [];

        // this.createAutoComplete();
      })
      .catch( e => console.error(e) );
    },

    fetchUserFavorites() {
      const userId = LocalStorageFuncs.fetchUserId();
      FLA_AXIOS('get', API + `/api/user/fetchUserFavorites/${userId}`)
      .then( res => {
        const { user } = res.data;
        this.userInfo = user;
        this.fetchPastOrders();
      } )
      .catch( e => console.error(e) );
    },

    handleChange() {
      const selectedLab = this.allLabs
        .find( lab => lab.labOptions.labName === this.selectedLab );

      // if no lab is found then we want to clear everything
      if ( !selectedLab ) {
        this.selectedLab = '';
        this.disableContinueBtn = true;
        this.labOptions = {};
        return;
      }

      // set labOptions
      this.labOptions = selectedLab.labOptions;

      this.disableContinueBtn = false;

      // run this to create a shopping cart, if one doesn't exist it will quick out
      this.createShoppingCart();
    },

    // creates cart in shopping cart object
    createShoppingCart() {
      if ( !this.shoppingCart[this.selectedLab] ) {
        this.shoppingCart[this.selectedLab] = {
          userId: this.userId,
          itemList: [],
          totalCostDollars: 0
        }
      }
    },

    clearShoppingCart() {
      this.shoppingCart = {
        totalCostDollars: 0,
        lineItems: []
      };
    },


    // used to create autoComplete section, autocompletes on a list of lab names
    createAutoComplete() {
      const autoCompleteList = this.allLabs.map( lab => lab.labOptions.labName );
      const el = document.getElementById('auto-complete');

      if ( el ) {
        new Awesomplete( el, {
          list: autoCompleteList,
          minChars: 2,
          maxItems: 10,
        } );

        el.addEventListener(
          'awesomplete-selectcomplete',
          (e) => {
            this.selectedLab = e.text.label;
            this.handleChange();

          }
        );
      }
    },


    // looks at current selected options data and adds an item to the cart
    addToCart() {

      const qty = this.lineQty;

      // basic line item
      const line = {
        itemTotal: 0,
        itemDetails: {},
        qty,
      };

      // get options, value will be the object key
      const selectElements = document.getElementsByClassName('option-selectors');
      for ( const el of selectElements ) {

        const name = el.name;

        // get options for select tag
        const optionElements = el.getElementsByTagName('option');
        for ( const option of optionElements ) {
          if ( !option.selected ) continue;

          const value = JSON.parse( option.value );
          line.itemTotal += value.costDollars;
          line.itemDetails[name] = value;
        }
      }    

      // this.shoppingCart[ this.selectedLab ].itemList.push( line );
      this.currentCart.itemList.push( line );

      this.computeCartTotal();
      this.lineQty = 1;
    },

    removeItem( idx ) {
      this.currentCart.itemList.splice(idx, 1);
      // this.shoppingCart[ this.selectedLab ].itemList.splice(idx, 1);
      this.computeCartTotal();
    },

    computeCartTotal() {
      // const currentCart = this.shoppingCart[ this.selectedLab ];
      
      const total = this.currentCart?.itemList?.map( x => x.itemTotal * x.qty ).reduce( (a,b) => a+b, 0);
      this.currentCart.totalCostDollars = total;
    },

    toggleCartView() {
      if ( !this.currentCart ) return;

      this.cartVisible = !this.cartVisible
    },

    toggleSelectLabModal() {
      const val = !this.showSelectLabModal;
      this.showSelectLabModal = val;

      if ( val ) {
        window.ShowBackdrop( true );
        this.$nextTick( this.createAutoComplete );
      }
      else {
        window.HideBackdrop( true );
      }
    },

    goToLabOrderPage( labId=undefined ) {
        const _labId = labId || this.labOptions._id;
        const path = `/lab/order?labId=${_labId}`;
        window.HideBackdrop( true );    // because backdrop might still on from toggleSelectLabModal
        router.push(path)
    },

    modifyFavorites( action, labId=undefined ) {
      // TODO: sanitize type

      const _labId = labId || this.labOptions._id;

      const data = { 
        labId: _labId, 
        action, 
        userId: this.userId 
      };

      FLA_AXIOS('post', API + '/api/user/modifyFavoriteLabs', data)
      .then( res => {
        NOTIFICATION( res.data );
        if ( res.data?.notification?.type === 'error' ) {
          return;
        }
        this.fetchUserFavorites();
      } )
      .catch( e => console.error(e) )
    },

    fetchPastOrders() {
      const userId = this.userInfo._id;
      FLA_AXIOS('get', API + '/api/order/pastOrders/' + userId)
      .then( res => {
        const { orders } = res.data;
        this.orders = orders;

        this.fetchOrderStatusArr();
      })
      .catch( e => console.error(e))
    },

    toggleOrderDetails( orderId=undefined ) {
      if ( !orderId ) {
        this.selectedOrderDetails = {};
        window.HideBackdrop( true );
        return;
      }

      const selectedOrderDetails = this.orders.find( x => x._id === orderId );

      if ( selectedOrderDetails ) {
        window.ShowBackdrop( true );
        this.selectedOrderDetails = selectedOrderDetails;
      }

    },

    stringToLocaleDate( string ) {
      return new Date( string || 0 ).toLocaleDateString();
    },

    fetchLabOptionsArrayMap() {
      FLA_AXIOS('get', API + '/api/labOptions/labOptionsArrayMap')
      .then( res => {
        const { labOptionsArrayMap } = res.data;
        this.labOptionsArrayMap = labOptionsArrayMap || {}
      })
      .catch( e => console.error(e) );
    },

    mutateItemDetails( itemObj ) {
      const { optionText, costDollars } = itemObj;
      return ( costDollars )
        ? `${optionText} - ($${costDollars})`
        : optionText;
    },

    showDetails( orderId ) {
      const order = this.orders.find( x => x._id === orderId );
      order.show = !order.show
    },

    fetchOrderStatusArr() {
      FLA_AXIOS('get', API + '/api/order/orderStatusArr')
      .then( res => {
        const { orderStatusArr } = res.data;
        this.orderStatusArr = orderStatusArr || [];

        // build a count for each status to be shown in filter drop down
        orderStatusArr.forEach( x => this.orderStatusCountMap[x] = 0 );
        this.orders.forEach( order => {
          this.orderStatusCountMap[ order.status ] ++;
        } );
      })
      .catch( e => console.error(e) );
    },



    // basic debugging to eliminate clicks
    debug() {
      const eventChange = new Event('change');
      const eventClick = new Event('click');
      setTimeout( () => {
        document.getElementById('auto-complete').dispatchEvent(eventChange);
        setTimeout( () => {
          document.getElementById('add-to-cart-btn').dispatchEvent(eventClick);
        }, 250 );
      }, 250 );
    }

  },
  mounted() {

    FLA_AXIOS = window.FLA_Axios;
    NOTIFICATION = window.showNotification;


    // fetch orders by labId
    this.fetchLabs();

    this.fetchUserFavorites();
    this.fetchLabOptionsArrayMap();

    // if not mobile then focus on Search input
    if ( !IsMobileDevice() ) {
      document.getElementById('search-input').focus();
    }


    // below is for debugging purposes
    // this.debug();

  }
}

</script>


<style scoped>

.line-item {
  border: 1px solid black;
  border-radius: 10px;
  background-color: antiquewhite;
  display: flex;
  flex-direction: column;
}

.sub-line-item {
  justify-content: space-around;
}

.sub-line-item div {
  width: calc( 50% - 1rem );
}

.left { text-align: left; }
.right { text-align: right; }

#shopping-cart-icon-wrapper {
  display: flex;
  flex-direction: row-reverse;
  cursor: pointer;
  position: relative;
}

#shopping-cart-icon {
  display: flex;
  background-color: gainsboro;
  padding: .5rem;
  justify-content: center;
  align-content: center;
  justify-items: center;
  border: 1px solid black;
  border-radius: 10px;
}

#shopping-cart-div {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: calc( 24px + 16px + 4px);
  right: 0;
  padding: 10px;
  background-color: gainsboro;
  font-size: small;
  min-width: 50%;
  z-index: 10;
  overflow: auto;
}

#new-order-div {
  background-color: lightgray;
  background-color: var(--fla-gray);
  border-radius: 10px;
  border: 2px solid black;
  margin-bottom: 1rem;
  padding: 1rem;
}

.new-order-wrapper{
  justify-content: space-between;
  align-items: baseline;
}

#select-lab-modal-wrapper, 
#order-details-modal-wrapper {
  position: fixed;
  z-index: 55;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 50%;
  max-height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#select-lab-modal, #order-details-modal {
  background-color: antiquewhite;
  border: 2px solid black;
  border-radius: 10px;
  padding: 1rem;
  max-width: calc( 100% - 4rem );
}

#select-lab-modal-header {
  display: flex;
  flex-direction: row-reverse;
}

#select-lab-modal-footer{
  margin-top: 1rem;
  justify-content: space-between;
  display: flex;
}

#favorite-labs {
  align-items: start;
}

.favorite-btn {
  background-color: bisque;
  /* background-color: var(--fla-button-blue); */
  background-color: #D5E8D4;
  border: 1px solid black;
  border-radius: 10px;
  padding: .25rem 1rem;
  align-items: center;
  transition: all .3s;
  cursor: pointer;
}

.favorite-btn:hover  {
  background-color: var(--fla-hover-green);
}


#past-orders-wrapper {
  background-color: antiquewhite;
  background-color: var(--fla-gray);
  border: 2px solid gray;
  border-radius: 10px;
}

.header div {
  padding: 0 .5rem;
  font-weight: bold;
}

.bold { font-weight: bold; }
.margin-left { margin-left: .5rem; }
.pointer { cursor: pointer; }

.info-line {
  width: fit-content;
  border-bottom: 1px solid gray;
  margin-bottom: .2rem;
}

.show-div {
  position: absolute;
  left: 0;
  bottom:0;
  background-color: gainsboro;
}




/* Table CSS */
.table-wrapper {
 overflow-x: auto;
 -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
}

.modern-table {
  width: 100%;
  border-collapse: collapse;
  /* margin: 20px 0; */
  margin: 1.25rem 0;
  /* font-size: 16px; */
  font-size: 1rem;
  text-align: left;
}

.modern-table thead tr {
  background-color: #009879;
  color: #ffffff;
  text-align: left;
  font-weight: bold;
}

.modern-table th,
.modern-table td {
  /* padding: 12px 15px; */
  padding: .75rem 1rem;
  /* white-space: nowrap; */
}

.modern-table tbody tr {
  border-bottom: 1px solid #dddddd;
  transition: all .3s;
}

.modern-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}

.modern-table tbody tr:last-of-type {
  border-bottom: 2px solid #009879;
}

.modern-table tbody tr:hover {
  background-color: #f1f1f1;
  background-color: var(--fla-hover-green);
  color: whitesmoke;
  /* cursor: pointer; */
}


@media (max-width: 600px) {
  .modern-table {
    margin: .75rem 0;
    font-size: 1rem;
  }
  .modern-table th,
  .modern-table td {
    padding: .75rem 1rem;
  }
}

label {
  margin: 0 .25rem;
  font-weight: bold;
}

</style>